module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800.woff2?1666787ea3ff3941e7641817eb9edc94";